// extracted by mini-css-extract-plugin
export default {"home":"c-i_cS","home__background":"c-i_cT","home__content":"c-i_cU"};